import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgPencilSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.325 7.675 4.086-4.086a2 2 0 1 1 2.828 2.828l-4.086 4.087M10.5 10.5l-4.397 4.397c-.598.598-.897.897-1.149 1.23q-.335.446-.584.946c-.186.374-.32.775-.587 1.577L3 21l2.434-.94c.707-.273 1.061-.41 1.392-.588a6 6 0 0 0 .837-.545c.297-.23.565-.498 1.101-1.034l4.564-4.565M9.657 17H7v-3M3 3l18 18"
    />
  </svg>
);
const Memo = memo(SvgPencilSlash);
export default Memo;
